import classNames from "classnames"

import { EditInPlace, IconButton } from "web/components"
import { useDialogModal, DialogCommands } from "web/hooks/modals"

export default function LookupValue({ value, readOnly }) {
  const dialogModal = useDialogModal()

  function handleChange(key) {
    return (changeValue) => {
      return value.update({ [key]: changeValue })
    }
  }

  function handleToggleHide() {
    return value.update({ disabled: !value.disabled })
  }

  async function handleDestroy() {
    const response = await value.destroy()

    if (response.result) return

    dialogModal({
      title: "Cannot Delete Value",
      prompt: response.errors,
      commands: [DialogCommands.OK],
    })
  }

  const classes = classNames(
    "grid items-center px-2 py-1.5 gap-x-2.5 bg-white",
    {
      "text-neutral-8": value.disabled,
    }
  )

  return (
    <div
      id={value.label.toLowerCase()}
      style={{ gridTemplateColumns: "1fr 2fr 26px 26px" }}
      className={classes}
    >
      <EditInPlace
        value={value.label}
        title={value.value}
        onChange={handleChange("label")}
        readOnly={readOnly}
      />
      <EditInPlace
        value={value.show_expression}
        placeholder="Show if..."
        onChange={handleChange("show_expression")}
        readOnly={readOnly}
      />
      <IconButton
        size="small"
        name={value.disabled ? "eye-slash" : "eye"}
        onClick={handleToggleHide}
        disabled={readOnly}
      />
      {value.customization_level !== "standard" && !readOnly && (
        <IconButton
          className="text-black"
          size="small"
          name={
            value.customization_level === "custom"
              ? "trash"
              : "arrow-uturn-left"
          }
          onClick={handleDestroy}
        />
      )}
    </div>
  )
}
